import * as THREE from 'three';
import * as CANNON from 'cannon';
import { CollisionGroups } from '../enums/CollisionGroups';

export class LineOfSightService {
    hasLineOfSight(
        from: THREE.Vector3,
        to: THREE.Vector3,
        physicsWorld: CANNON.World,
    ): boolean {
        const cannonFrom = new CANNON.Vec3(from.x, from.y, from.z);
        const cannonTo = new CANNON.Vec3(to.x, to.y, to.z);
        const result = new CANNON.RaycastResult();

        const hit = physicsWorld.raycastClosest(cannonFrom, cannonTo, {
            collisionFilterMask: CollisionGroups.Default,
            skipBackfaces: true,
        }, result);

        if (!hit) { return true; }

        const hitPoint = new THREE.Vector3(
            result.hitPointWorld.x,
            result.hitPointWorld.y,
            result.hitPointWorld.z,
        );
        // LOS is clear only if the obstacle is at or past the target's distance
        return hitPoint.distanceTo(from) >= from.distanceTo(to) - 0.1;
    }
}
